// plain version
export function toCamelCaseObj(obj: Record<string, unknown>): Record<string, any> {
  return Object.keys(obj).reduce((acc, key) => {
    const camelKey = key.replace(/_([a-z])/g, g => g[1].toUpperCase());

    const value = obj[key];
    if (Array.isArray(value)) {
      acc[camelKey] = value.map(item =>
        typeof item === 'object' && item !== null
          ? toCamelCaseObj(item as Record<string, unknown>)
          : item
      );
    } else if (typeof value === 'object' && value !== null) {
      acc[camelKey] = toCamelCaseObj(value as Record<string, unknown>);
    } else {
      acc[camelKey] = value;
    }

    return acc;
  }, {} as Record<string, any>);
}

export function getValueByPath(obj: Record<string, any>, path: string): any {
  return path.split('.').reduce((acc, key) => {
    return acc[key] || {};
  }, obj);
}
